import { mobile, api } from '@bilibili-maoer/web-utils';

var appId = 'wx61243524441407be'; // 微信公众号 id

var fmAppId = 'wx143bd0e4a3b523cf'; // 猫耳 fm 的应用 id

var isWxOpenBtn = mobile.isWeixinBrowser() && mobile.isAndroid();
var LAND_PAGE_URL = "".concat(api.MISSEVAN_MOBILE_API_PREFIX_URL, "/app/download-landing");

export { LAND_PAGE_URL, appId, fmAppId, isWxOpenBtn };
